export const path = {
  resultLoading: '/result-loading',
};
